import type { ActionTree, Module } from 'vuex'
import { CompaniesService } from '@/services/Companies.service'
import IApiBaseService from '@/services/interfaces/IApiBase.service'
import {
  createBaseActions,
  createBaseMutations,
  createBaseState,
} from '@/store/modules/Base.module'
import { Company, CompanyPagedResult } from '@/classes/generated-models'
import { IBaseModuleState } from '@/store/interfaces/IBase.module'
import { ShowLoadingAfterMs } from '@/constants'
import type { IState } from '@/store'

export interface ICompaniesState extends IBaseModuleState<Company, CompanyPagedResult> {}

const companiesService: IApiBaseService<Company, CompanyPagedResult> = new CompaniesService()

const state = (): ICompaniesState => ({
  ...createBaseState<Company, CompanyPagedResult>(companiesService),
})

const actions: ActionTree<ICompaniesState, IState> = {
  ...createBaseActions<Company, CompanyPagedResult>(),
  async fetchDataNoPaging({ commit, state }) {
    const timer = setTimeout(() => commit('setLoading', true), ShowLoadingAfterMs)
    try {
      const response = await state.service.getAll('', { pageSize: 99999999 })
      commit('setData', response)
    } finally {
      clearTimeout(timer)
      commit('setLoading', false)
    }
  },
}

export const Companies: Module<ICompaniesState, IState> = {
  namespaced: true,
  state,
  mutations: {
    ...createBaseMutations<Company, CompanyPagedResult>(),
  },
  actions,
}
